const state = {
    welcome: [],
    loading: false,
};

export default state;